import { ReactNode } from 'react';

interface SidebarDesktopProps {
  children: ReactNode;
}

const SidebarDesktop = ({ children }: SidebarDesktopProps) => {
  return (
    <div className="hidden md:flex md:flex-shrink-0">
      <div className="flex flex-col w-64">
        <div className="flex flex-col flex-1 h-0">
          <div className="z-10 flex items-center flex-shrink-0 h-16 px-4 py-4 bg-main-900 border-b border-b-main-800">
            <img
              className="h-8 mx-auto"
              src="/images/wielscomply-logo-negatief.svg"
              alt="WielsComply"
            />
          </div>
          <div className="flex flex-col flex-1 overflow-y-auto">
            <nav className="flex-1 px-2 py-4 bg-main-900">{children}</nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarDesktop;
